import { apiFetch } from "./client";

export const fetchProfileDashboard = () =>
  apiFetch("/enduser/profile-dashboard/", {
    credentials: "include",
  });

const isMeaningfulProfileValue = (value) => {
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized &&
    !["—", "none", "null", "undefined", "na", "n/a"].includes(normalized)
  );
};

export const hasRequiredPersonalInfo = (personalInfo) => {
  if (!personalInfo || typeof personalInfo !== "object") return false;

  return (
    isMeaningfulProfileValue(personalInfo.first_name) &&
    isMeaningfulProfileValue(personalInfo.email)
  );
};

export const hasRequiredAddressInfo = (address) => {
  if (!address || typeof address !== "object") return false;

  return ["address_line1", "city", "state", "pincode"].every((field) =>
    isMeaningfulProfileValue(address[field])
  );
};

export const updateProfile = (payload) =>
  apiFetch("/enduser/profile/", {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: payload, 
  });
